module.exports = __webpack_public_path__ + "static/media/threshold.6be48a85.png";